import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  h1 {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  margin-top: 10px;
  button:nth-of-type(2) {
    border-radius: 0 5px 5px 0;
  }
  button:nth-of-type(1) {
    border-radius: 5px 0 0 5px;
  }
`;

export const ButtonRepeatYearly = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  margin-left: 2px;
  label {
    div {
      width: 15px;
      height: 15px;
      min-height: 15px;
      min-width: 15px;
      border-radius: 3px;
    }
  }
`;

export const ButtonDay = styled.button<{ selected: boolean }>`
  padding: 8px 16px;
  border: none;
  background-color: ${({ selected }) => (selected ? colors.brand.primary.base : colors.Grey100)};
  color: ${({ selected }) => (selected ? 'white' : colors.text['sub-500'])};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
`;

export const ContainerExceptionGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 0.8fr 0.8fr 0.8fr 0.8fr;
  color: ${colors.text['sub-500']};
  span {
    margin-bottom: 3px;
  }
`;

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  label {
    font-weight: 600;
    margin-bottom: 5px;
    color: ${colors.Blue300};
  }
  span {
    color: ${colors.brand.primary.dark} !important;
    font-weight: 700;
  }
`;

export const DateLabel = styled.span`
  transition: all 0.2s;
  margin-left: 14px;
  margin-right: 5px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 13px;
  color: ${colors.Blue300};
`;

export const ContentDate = styled.div`
  /* Input de data */
  position: relative;
  border: 1px solid ${colors.Grey200};
  border-radius: 5px;
  min-height: 50px;
  min-width: 300px;
  height: 55px;
  background-color: white;
  .react-datepicker__month-text--keyboard-selected {
    background-color: ${colors.BlueSecondary};
    color: white;
  }
  .CalendarMonth_caption {
    text-transform: capitalize;
  }
  .react-datepicker__triangle {
    left: -130px !important;
  }
  .react-datepicker__header {
    background-color: white;
    border-bottom: none;
  }

  .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::after {
    display: none;
  }

  .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
    display: none;
  }
  .react-datepicker-wrapper {
    display: block;
    .react-datepicker__input-container {
      top: -5px;
      input[type="text"] {
        border: none;
        font-size: 12px;
        outline: none;
        line-height: 19px;
        padding: 0 40px 0 14px;
        color: #464555;
        background: transparent;
      }
    }
  }
  .SingleDatePicker {
    display: block;
    position: initial;
  }
  .SingleDatePickerInput {
    display: block;
    position: relative;
    border: none;
    background: transparent;
    top: -30px;
    .DateInput {
      display: block;
      position: relative;
      width: 100%;
      background: transparent;
      /* Valor que aparece no input */
      .DateInput_input {
        position: relative;
        top: 29px;
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0 40px 0 14px;
        font-weight: 300;
        color: ${colors.Black};
        width: 100%;
        background: transparent;
        border: none;
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .DateRangePickerInput {
    .DateRangePickerInput_arrow {
      width: 60px;
    }
    .DateInput {
      .DateInput_input {
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0 40px 0 14px;
        color: ${colors.Grey400};
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .SingleDatePicker_picker {
    width: 100%;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.White};
    font-weight: bold;
  }
  .CalendarDay__selected:hover {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.Black};
  }
  .DayPickerKeyboardShortcuts_show {
    display: unset;
  }
  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    border-right: 33px solid ${colors.BlueSecondary};
    display: none;
  }
  .DayPickerKeyboardShortcuts_show__bottomRight:hover::before {
    border-right: 33px solid ${colors.BlueSecondary};
  }

  span {
    cursor: pointer;
    color: ${colors.Blue300};
    margin-top: 5px;
  }
`;

export const ContainerCardDays = styled.div`
  margin-top: 10px;
  h4 {
    font-weight: 600;
  }
  span {
    font-weight: 600;
  }
`;

export const Button = styled.div`
  max-width: 300px;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 5px;
  cursor: pointer;
  border: 1.5px solid ${colors.Blue300};
  color: ${colors.Blue300};
  span {
    font-weight: 600;
  }
`;

export const WeekDayButton = styled.div<{ checked: boolean }>`
  padding: 8px;
  border-radius: 5px;
  margin: 5px;
  height: 50px;
  align-items: center;
  text-align: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  background-color: ${({ checked }) => (checked ? colors.bg['primary-base'] : 'lightgrey')};
  color: ${({ checked }) => (checked ? 'white' : 'black')};

`;

export const InputStyledContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 300px;
  height: 50px;
  color: ${colors.Blue300};
  label {
    position: absolute;
    top: 5px;
    font-size: 12px;
    left: 11px;
    font-weight: bold;
  }
  button:nth-of-type(1) {
    border: unset !important;
    background: none;
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 0;
    font-size: 12px;
    font-weight: bold;
  }
  button:nth-of-type(2) {
    background: none;
    border: unset !important;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 0;
    font-size: 12px;
    font-weight: bold;
  }
`;

export const InputStyle = styled.input`
  padding-top: 20px !important;
  height: 100%;
  font-size: 14px !important;
  &::-webkit-calendar-picker-indicator {
    display: none;
    appearance: none;
  }
`;

export const InputStyleHour = styled(InputStyle)`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.Grey200};
  font-size: 16px;
  color: ${colors.brand.primary.base};
`;

export const ContainerInputs = styled.div<{ marginBottom?: number }>`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: ${({ marginBottom }) => marginBottom || 20};
  div {
    flex-wrap: nowrap;
  }
`;

export const ButtonArrowBottom = styled.div`
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 28px;
  padding: 0;
  height: 14px;
`;

export const ButtonArrowTop = styled.div`
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 12px;
  padding: 0;
  height: 14px;
`;

export const TrashIconContainer = styled.div`
  svg {
    width: 24px;
    height: 24px;
  }

`;

export const ContainerHoursView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  color: ${colors.text['sub-500']};
  p {
    margin-bottom: 5px;
  }
`;

export const ContainerExceptionsView = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 15px;
  font-size: 14px;
  color: ${colors.text['sub-500']};
`;
